<template>
  <div class="adminLoadingAnimation">
    <div class="dot dot1"></div>
    <div class="dot dot2"></div>
    <div class="dot dot3"></div>
    <div class="dot dot4"></div>
  </div>
</template>
<style scoped>
.adminLoadingAnimation {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 89px);
  padding-bottom: 60px;
  background-color: #e1e1e19e;
}

.dot {
  width: 17px;
  height: 17px;
  margin: 0 10px;
  border-radius: 50%;
  animation: bounce 1s infinite ease-in-out;
}

.dot1 {
  animation-delay: 0s;
  background-color: #1e417d;
}

.dot2 {
  animation-delay: 0.2s;
  background-color: #416bb3;
}

.dot3 {
  animation-delay: 0.4s;
  background-color: #8aa8db;
}
.dot4 {
  animation-delay: 0.6s;
  background-color: #ccdaf3;
}
</style>